import { Alert, Box, Divider, Typography } from "@mui/material";

import type { FormattedShipmentSection } from "./utils";

interface Props {
  section: FormattedShipmentSection;
}

export function SectionDisplay(props: Props) {
  const { section } = props;

  return (
    <Box mb={3} sx={{ minWidth: 0, maxWidth: "100%" }}>
      <Typography variant="h6" color="primary" gutterBottom sx={{ mb: 1 }}>
        {section.title}
      </Typography>

      {section.warningText && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {section.warningText}
        </Alert>
      )}

      {section.infoText && (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ mb: 2, fontWeight: "bold", fontStyle: "italic" }}
        >
          {section.infoText}
        </Typography>
      )}

      <Box
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          sm: "repeat(auto-fit, minmax(250px, 1fr))",
          md: "repeat(auto-fit, minmax(300px, 1fr))",
          lg: "repeat(3, 1fr)",
        }}
        gap={2}
        mb={2}
        sx={{ minWidth: 0 }}
      >
        {section.items.map((item) => (
          <Box
            key={`${section.title}-${item.label}`}
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            sx={{
              gridColumn:
                section.items.length === 1 ? { lg: "span 3" } : "auto",
              minWidth: 0,
              maxWidth: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{
                fontWeight: "medium",
                minWidth: "80px",
                mr: 1,
                flexShrink: 0,
              }}
            >
              {item.label}:
            </Typography>

            <Typography
              variant="subtitle2"
              sx={{
                minWidth: 0,
                flex: 1,
                overflowWrap: "anywhere",
                wordBreak: "break-word",
                hyphens: "auto",
                whiteSpace: "pre-line",
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider />
    </Box>
  );
}
